module.exports = __webpack_public_path__ + "img/ntk_nav_delete_w.eb138898.svg";